import { PageSubtitle, PageTitle } from "@/shared/ui";
import { Card } from "@tremor/react";
export default function Layout({
  children
}: {
  children: any;
}) {
  return <>
      <main className="flex flex-col h-full">
        <div className="mb-4">
          <PageTitle data-sentry-element="PageTitle" data-sentry-source-file="layout.tsx">Settings</PageTitle>
          <PageSubtitle data-sentry-element="PageSubtitle" data-sentry-source-file="layout.tsx">Setup and configure Keep</PageSubtitle>
        </div>
        {children}
      </main>
    </>;
}